import { Model } from "@vuex-orm/core";

export default class ResolutionCatalogTag extends Model {
  static get entity() {
    return "resolution_catalog_tag";
  }

  static fields() {
    return {
      id: this.attr(null),
      resolution_catalog_id: this.attr(null),
      tag_id: this.attr(null),

      created: this.attr(null),
      updated: this.attr(null),
      deleted: this.attr(null), // ???: ..
      agency_id: this.attr(null),
    };
  }
}
